

export const GOOGLE_API_KEY = "AIzaSyCNSyo_2VV7gd4pNBkZnDlHTce_KDPSPSs";

export const SUGGESTED_VIDEOS = "https://youtube.googleapis.com/youtube/v3/videos?part=snippet%2CcontentDetails%2Cstatistics&chart=mostPopular&regionCode=US&key=" + GOOGLE_API_KEY


export const YOUTUBE_VIDEOS_API =
  "https://www.googleapis.com/youtube/v3/search?part=snippet&maxResults=30&order=viewCount&type=video&videoCategoryId=10&key=" +
  GOOGLE_API_KEY;


export const YOUTUBE_SEARCH_API =
  "http://suggestqueries.google.com/complete/search?client=youtube&ds=yt&client=firefox&q=";


  export const MENU_LOGO = "https://static.vecteezy.com/system/resources/previews/021/190/402/original/hamburger-menu-filled-icon-in-transparent-background-basic-app-and-web-ui-bold-line-icon-eps10-free-vector.jpg";

  export const YOUTUBE_LOGO = "https://betanews.com/wp-content/uploads/2017/08/new-youtube-logo.jpg";

  export const USER_LOGO = "https://logodix.com/logo/248174.jpg";



  export const YOUTUBE_SEARCH_BY_KEYWORD = "https://www.googleapis.com/youtube/v3/search?part=snippet&maxResults=50&q="